import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('uniformity')
document.body.insertAdjacentHTML(
  'beforeend',
  stageMarkup({ controls: ['exit', 'prev', 'next', 'hide'] }),
)
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

const modes = ['#000000', '#1a1a1a', '#404040', '#808080', '#c0c0c0', '#ffffff', 'blocks'] as const
let index = 0

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  if (!stage || !canvas) return

  const paint = () => {
    const mode = modes[index]
    canvas.replaceChildren()
    if (mode === 'blocks') {
      canvas.style.background = '#000'
      const grid = document.createElement('div')
      grid.style.cssText =
        'display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(3,1fr);width:100%;height:100%'
      for (let i = 0; i < 9; i += 1) {
        const cell = document.createElement('div')
        const v = 20 + i * 28
        cell.style.background = `rgb(${v} ${v} ${v})`
        grid.appendChild(cell)
      }
      canvas.appendChild(grid)
    } else {
      canvas.style.background = mode
    }
    const label = stage.querySelector('[data-stage-label]')
    if (label) label.textContent = String(mode)
  }

  const close = openStage(stage, {
    onExit: () => {
      close()
    },
    onPrev: () => {
      index = (index - 1 + modes.length) % modes.length
      paint()
    },
    onNext: () => {
      index = (index + 1) % modes.length
      paint()
    },
  })
  paint()
})
